module.exports = __webpack_public_path__ + "media/navi/icon_pin-01e75992.png";